export type SystemOverviewSubpage = "rabbitmq" | "cpu" | "hdd" | "interface";

export const SystemOverviewSubpages = {
  rabbitmq: "RabbitMQ",
  cpu: "CPU",
  hdd: "HDD",
};
